export const CONTROL_INFO_SUBMITTING = 'CONTROL_INFO_SUBMITTING';
export const CONTROL_INFO_FETCHING = 'CONTROL_INFO_FETCHING';
export const CONTROL_INFO_SUBMIT_ERROR = 'CONTROL_INFO_SUBMIT_ERROR';
export const CONTROL_INFO_FETCH_ERROR = 'CONTROL_INFO_FETCH_ERROR';
export const CONTROL_INFO_SUBMIT_SUCCESS = 'CONTROL_INFO_SUBMIT_SUCCESS';
export const CONTROL_INFO_GET_DISTRICT_INFO = 'CONTROL_INFO_GET_DISTRICT_INFO';
export const CONTROL_INFO_CLEAR_ERROR_SUCCESS =
  'CONTROL_INFO_CLEAR_ERROR_SUCCESS';

//mobile inventory license
export const MOBILE_INVENTORY_LICENSE_COUNT_FETCHING =
  'MOBILE_INVENTORY_LICENSE_COUNT_FETCHING';
export const MOBILE_INVENTORY_LICENSE_COUNT_DATA =
  'MOBILE_INVENTORY_LICENSE_COUNT_DATA';
export const MOBILE_INVENTORY_LICENSE_COUNT_FETCH_ERROR =
  'MOBILE_INVENTORY_LICENSE_COUNT_FETCH_ERROR';
export const MOBILE_SYNC_INFO_FETCHING = 'MOBILE_SYNC_INFO_FETCHING';
export const MOBILE_SYNC_INFO_DATA = 'MOBILE_SYNC_INFO_DATA';
export const MOBILE_SYNC_INFO_FETCH_ERROR = 'MOBILE_SYNC_INFO_FETCH_ERROR';



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/districtInfo/types.js